import { BaseClient } from './BaseClient'

export class WikiApi extends BaseClient {
  getWiki = this.createRequest({
    url: '/api/wiki-pages?populate[]=localizations',
    method: 'get',
  })
  getWikiSeo = this.createRequest({
    url: '/api/wiki-page-home',
    method: 'get',
  })
}
